<div class="d-flex justify-content-between">
  <div
    class="font-5 d-flex align-items-center position-relative me-2 user-card fw-light primary-border p-2 rounded-3"
    [ngClass]="isNumericValue() ? 'w-80' : 'w-100'"
  >
    {{ name() }}
  </div>

  <div
    class="font-5 d-flex align-items-center position-relative me-2 user-card fw-light primary-border p-2 rounded-3"
    [ngClass]="isNumericValue() ? 'w-20 justify-content-center' : 'w-100'"
  >
    @if (isList()) {
      <ul class="property-values mb-0 ps-3">
        @for (item of listItems(); track $index) {
          <li>{{ item }}</li>
        }
      </ul>
    } @else {
      {{ value() }}
    }
  </div>
</div>